/***************************************************************************************************************************
 * Responsibility - Renders an individual artwork with all the necessary actions and information for the proofing process 🐺
 * *************************************************************************************************************************
 *
 * @format */

import {DESIGN_COMMENT_TYPE_PROOFING, PRODUCT_TYPE_CARTON} from 'frontier-constants';
import {useProofingContext} from '../../proofing_context_provider';
import {TableColumnActions} from './table_column_actions';
import {TableColumnArtwork} from './table_column_artwork';
import NumberFormat from 'react-number-format';
import {If, IfElse} from 'frontier-utilities';
import React from 'react';

// styles
import '../single_design_proof.scss';

export const ProofPressReady = props => {
    const proofingCtx = useProofingContext();
    const {handleCollapse, handleUndoDesignReview} = proofingCtx;

    const {lastDesignToReviewId, isPrintedProof, currentProof, shareLink, shareKey, order} =
        proofingCtx.data;

    const {designOrder} = props;

    const {design} = designOrder;

    const proofingComments = design.design_comments.filter(
        c => c.type_id === DESIGN_COMMENT_TYPE_PROOFING && c.is_archived === false
    );

    const isPressReady = designOrder.design.pressready_key !== null;
    return (
        <div
            className={`proof_press_ready-56ht ${
                isPressReady ? '' : 'proof_press_ready-56ht--not-press-ready'
            }`}>
            {/* Artwork column*/}
            <TableColumnArtwork
                isPrintedProof={isPrintedProof}
                designOrder={designOrder}
                onCollapse={handleCollapse}
                shareLink={shareLink}
                order={order}
            />

            {/* Design Id column*/}
            <div className="proof-press-ready-56ht--column proof-press-ready-56ht__design-id">
                <div className="column-56ht__header">
                    <h5 className="m-0">Design ID</h5>
                </div>
                <p className="column-56ht__design-order-id">{designOrder.design.id}</p>
            </div>

            {/* Design Qty column*/}
            <div className="proof-press-ready-56ht--column proof-press-ready-56ht__qty">
                <div className="column-56ht__header">
                    <h5 className="m-0">Qty</h5>
                </div>
                <p className="column-56ht__design-qty">
                    <NumberFormat
                        thousandSeparator={true}
                        value={designOrder.qty}
                        displayType={'text'}
                    />
                </p>
            </div>

            {/* Design face column. For Front and Back Only */}
            <IfElse condition={designOrder.design.is_linked}>
                <div className="proof-press-ready-56ht--column proof-press-ready-56ht__facing">
                    <IfElse condition={order.product_type_id === PRODUCT_TYPE_CARTON}>
                        <>
                            <div className="column-56ht__header">
                                <h5 className="m-0">Carton Face</h5>
                            </div>

                            <p className="column-56ht__design-facing">
                                {designOrder.design.print_sequence === 1 ? 'Outside' : 'Inside'}
                            </p>
                        </>
                        <>
                            <div className="column-56ht__header">
                                <h5 className="m-0">Label Sequence</h5>
                            </div>

                            <p className="column-56ht__design-facing">
                                {designOrder.design.print_sequence === 1 ? 'Front' : 'Back'}
                            </p>
                        </>
                    </IfElse>
                </div>
                <div className="proof-press-ready-56ht--column proof-press-ready-56ht__facing">
                    <div className="column-56ht__header">
                        <h5 className="m-0"> </h5>
                    </div>
                    <p className="column-56ht__design-facing"> </p>
                </div>
            </IfElse>

            {/* Actions */}
            <TableColumnActions
                handleUndoDesignReview={handleUndoDesignReview}
                lastDesignToReviewId={lastDesignToReviewId}
                currentProof={currentProof}
                designOrder={designOrder}
            />

            {/* design order notes */}
            <If
                condition={
                    proofingComments.length > 0 ||
                    !!currentProof.comment ||
                    designOrder.design.pressready_key == null
                }>
                <div className="proof-press-ready-56ht--notes">
                    <If condition={!!currentProof.comment}>
                        <div className="mb-4">
                            <h3 className="color-structure-black">All Designs</h3>
                            <p className="oder-notes-44oo__notes mb-0 ms-0">
                                {currentProof.comment}
                            </p>
                        </div>
                    </If>

                    <If condition={proofingComments.length > 0}>
                        <h3 className="color-structure-black">Artwork Specific Notes</h3>
                        {proofingComments.map((c, i) => (
                            <div
                                key={`${c.id}-${i}`}
                                className="mt-0 mb-2 ms-auto me-0"
                                dangerouslySetInnerHTML={{
                                    __html: c.content
                                }}
                            />
                        ))}
                    </If>

                    {/* Not ready to be processed alert */}
                    <If condition={designOrder.design.pressready_key === null}>
                        <div className="proof-press-ready-56ht--not-ready-alert mt-4">
                            <div className="alert alert-info w-100">
                                <p className="m-0 p-0">
                                    This design is still being processed by us and will be seen here
                                    when it is press ready and ready for your review
                                </p>
                            </div>
                        </div>
                    </If>
                </div>
            </If>
        </div>
    );
};
